module.exports = __webpack_public_path__ + "media/images/row3_img4-523e00552dc94482cf1b028fc733e3f8.jpg";